export default __webpack_public_path__ + "static/media/insta.0963b7a5.png";